import * as v from 'valibot';
import type { FieldDefinition } from '@v2/components/SchemaForm/types';

export const domainSchema = v.object({
  domain: v.pipe(v.string(), v.minLength(1, 'Domain is required')),
});

export type DomainFormValues = v.InferOutput<typeof domainSchema>;

export const domainFields: FieldDefinition[] = [
  { name: 'domain', label: 'Domain', type: 'text', placeholder: "ex: 'gmail.com'" },
];
